import {
    Anchor,
    Button,
    Flex,
    Group,
    Paper,
    PasswordInput,
    TextInput,
    Title,
    LoadingOverlay,
    Text,
    Image,
} from '@mantine/core'

import { useForm } from '@mantine/form'
import { useFormHandler } from '@utils/useFormHandler'
import { useContext, useEffect } from 'react'
import { IRequestLogin, IResponseLogin } from '@apiinterface/IAuth'
import { AuthContext } from '@context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { modals } from '@mantine/modals'
import FormForgetPassword from '@components/form/FormForgetPassword'
import MTLLOGO from '../images/MTLLOGO.svg'
const Login = () => {
    const { login, isAuthenticated } = useContext(AuthContext)
    const navigate = useNavigate()
    useEffect(() => {
        if (isAuthenticated === true) {
            navigate('/backend/home')
        }
    }, [isAuthenticated, navigate])
    const openForgetPassword = () =>
        modals.open({
            title: 'กู้รหัสผ่านบัญชี',
            children: <FormForgetPassword />,
        })

    const form = useForm({
        initialValues: {
            username: '',
            password: '',
        },
    })
    const { loading, onSubmit } = useFormHandler<IRequestLogin, IResponseLogin>(
        'post',
        '/auth/login',
        form,
        login
    )

    return (
        <Flex
            justify='center'
            direction='column'
            align='center'
            w='100%'
            mih='100vh'
            bg='blue.6'
        >
            <Paper
                maw={400}
                shadow='xl'
                w='100%'
                mx='auto'
                p='xl'
                m='xl'
                my='auto'
                bg='white'
                radius='lg'
                pos='relative'
                style={{ overflow: 'hidden' }}
            >
                <LoadingOverlay visible={loading} />
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Flex justify='center' mb='lg'>
                        <Image w={100} ml='lg' src={MTLLOGO} />
                    </Flex>
                    <Title order={3} ta='center' c='text.2'>
                        เข้าสู่ระบบ
                    </Title>
                    <Text size='xs' ta='center' mb='lg' mt='sm' c='text.2'>
                        ยินดีต้อนรับเข้าสู่
                        ระบบจัดการระบบคำนวณเงินทุนเพื่อการเกษียณอายุ
                    </Text>
                    <TextInput
                        withAsterisk
                        label='ชื่อผู้ใ้ช้งาน'
                        placeholder='ชื่อผู้ใ้ช้งาน'
                        {...form.getInputProps('username')}
                    />
                    <PasswordInput
                        withAsterisk
                        mt='md'
                        label='รหัสผ่าน'
                        placeholder='รหัสผ่าน!'
                        {...form.getInputProps('password')}
                    />

                    <Group justify='end' mt='lg'>
                        <Anchor
                            type='button'
                            c='fuchasia.4'
                            component='button'
                            onClick={openForgetPassword}
                            size='sm'
                        >
                            ลืมรหัสผ่าน?
                        </Anchor>
                    </Group>
                    <Button
                        radius='xl'
                        color='fuchasia.4'
                        type='submit'
                        fullWidth
                        fz='sm'
                        size='md'
                        mt='md'
                    >
                        เข้าสู่ระบบ
                    </Button>
                </form>
            </Paper>
            <Text c='text.0' size='xs' p='lg'>
                Copyright © 2022 Muang Thai Life Assurance Public Company
                Limited.
            </Text>
        </Flex>
    )
}

export default Login
